import type { NavigationItem } from '@wizbii-components/bo-angular-ui';

import { Injectable } from '@angular/core';
import { FEATURES_ROUTING } from '@features/routes';
import { RoleEnum } from '@models/commons/role';

interface NavigationItemCustom extends NavigationItem {
  grantedTo: RoleEnum;
}

const NavigationMenu: readonly NavigationItemCustom[] = [
  {
    route: FEATURES_ROUTING.Partners,
    label: 'Les plateformes',
    icon: 'icons/layers',
    grantedTo: RoleEnum.ROLE_CONFIGURATOR_LOYALTY,
  },
  {
    route: FEATURES_ROUTING.Services,
    label: 'Services partenaires',
    icon: 'icons/globe',
    grantedTo: RoleEnum.ROLE_SERVICES_LOYALTY,
  },
  {
    route: FEATURES_ROUTING.Users,
    label: 'Utilisateurs',
    icon: 'icons/people',
    grantedTo: RoleEnum.ROLE_SUPPORT_LOYALTY,
  },
  {
    route: FEATURES_ROUTING.LifeMoments,
    label: 'Moments de vie',
    icon: 'icons/life-moments',
    grantedTo: RoleEnum.ROLE_SERVICES_LOYALTY,
  },
  {
    route: FEATURES_ROUTING.CRM,
    label: 'Gestion des mails',
    icon: 'icons/letter',
    grantedTo: RoleEnum.ROLE_CRM_LOYALTY,
  },
  {
    route: FEATURES_ROUTING.DevTools,
    label: 'Dev tools',
    icon: 'icons/calendar',
    grantedTo: RoleEnum.ROLE_CONFIGURATOR_LOYALTY,
  },
] as const;

@Injectable({ providedIn: 'root' })
export class NavigationMenuService {
  readonly #navigationMenu = NavigationMenu;

  readonly getMenu = (roles: string[]): NavigationItemCustom[] =>
    this.#navigationMenu.filter((item) => roles.includes(item.grantedTo));

  readonly getFirstGrantedItemRoute = (roles: string[]): string | string[] =>
    this.#navigationMenu.find((item) => roles.includes(item.grantedTo))?.route ?? [];
}
